import React from 'react'
import { IMAGES } from '../../constants'

const Loader = () => {
    return (
        <div className="loader-container d-flex justify-content-center align-items-center">
            <img src={IMAGES.LOGO} alt="Loading" className="loader-logo" />
        </div>
        // <div className="loading">Loading&#8230;</div>
    )
}

export default Loader
